export type CookieConsentChoice = 'all' | 'essential';

const CONSENT_STORAGE_KEY = 'cookie-consent';
const ANALYTICS_GRANTED = 'analytics-granted';
const ANALYTICS_DENIED = 'analytics-denied';

export function recordCookieConsent(choice: CookieConsentChoice): void {
  localStorage.setItem(
    CONSENT_STORAGE_KEY,
    choice === 'all' ? ANALYTICS_GRANTED : ANALYTICS_DENIED,
  );
  window.dispatchEvent(new CustomEvent('cookieConsentChanged', {
    detail: { analytics: choice === 'all' },
  }));
}

export function hasAnalyticsConsent(): boolean {
  try {
    const recorded = localStorage.getItem(CONSENT_STORAGE_KEY);
    // Keep consent granted under the value written by earlier releases.
    return recorded === ANALYTICS_GRANTED || recorded === 'accepted';
  } catch {
    return false;
  }
}
